// Generated by purs version 0.15.14
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_List_Types.foldableList)(Fusion_Data_Bytes.monoidBytes);
var map = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var greaterThan = /* #__PURE__ */ Data_Ord.greaterThan(Fusion_Data_Timestamp.ordTimestamp);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "loadedBytes";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "timestamp";
    }
})(Fusion_Data_Timestamp.showTimestamp))(Fusion_Data_Bytes.showBytes)));
var lessThan = /* #__PURE__ */ Data_Ord.lessThan(Fusion_Data_Duration.ordDuration);
var greaterThanOrEq = /* #__PURE__ */ Data_Ord.greaterThanOrEq(Fusion_Data_Duration.ordDuration);
var fold1 = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Fusion_Data_Bytes.monoidBytes);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var NtmStreamModel = function (x) {
    return x;
};
var windowSpeed = function (v) {
    var v1 = Data_List.head(v.window);
    if (v1 instanceof Data_Maybe.Nothing) {
        return Data_Maybe.Nothing.value;
    };
    if (v1 instanceof Data_Maybe.Just) {
        var duration = Fusion_Data_Timestamp.diff(v1.value0.timestamp)(v.windowStart);
        var bytes = fold(map(function (v2) {
            return v2.loadedBytes;
        })(v.window));
        var speed = Fusion_Data_Speed.bytesPerDuration(bytes)(duration);
        return new Data_Maybe.Just({
            speed: speed,
            timestamp: v1.value0.timestamp
        });
    };
    throw new Error("Failed pattern match at Fusion.DataProcessing (line 158, column 3 - line 169, column 12): " + [ v1.constructor.name ]);
};
var updateReverseWindow = function (dictMonadError) {
    var MonadThrow0 = dictMonadError.MonadThrow0();
    var throwError = Control_Monad_Error_Class.throwError(MonadThrow0);
    var Monad0 = MonadThrow0.Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = discard(Bind1);
    var Applicative0 = Monad0.Applicative0();
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var when = Control_Applicative.when(Applicative0);
    var bind = Control_Bind.bind(Bind1);
    var pure = Control_Applicative.pure(Applicative0);
    return function (v) {
        return function (event) {
            return function (model) {
                var err = function (message) {
                    return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl60.value)(message));
                };
                return discard1(for_(Data_Array.last(model.reverseWindow))(function (last) {
                    return when(greaterThan(last.timestamp)(event.timestamp))(err("DataProcessing.updateReverseWindow: event has earlier timestamp then its predecessor: " + show(event)));
                }))(function () {
                    var widenedWin = Data_Array.snoc(model.reverseWindow)(event);
                    var partingIndex = Data_Array.findIndex(function (v1) {
                        return lessThan(Fusion_Data_Timestamp.diff(event.timestamp)(v1.timestamp))(v.coalesceInterval);
                    })(widenedWin);
                    return bind((function () {
                        if (partingIndex instanceof Data_Maybe.Just) {
                            return pure({
                                reverseWindow: Data_Array.drop(partingIndex.value0)(widenedWin),
                                reverseWindowStart: (function () {
                                    var v1 = Data_Array.index(widenedWin)(partingIndex.value0 - 1 | 0);
                                    if (v1 instanceof Data_Maybe.Just) {
                                        return v1.value0.timestamp;
                                    };
                                    if (v1 instanceof Data_Maybe.Nothing) {
                                        return model.reverseWindowStart;
                                    };
                                    throw new Error("Failed pattern match at Fusion.DataProcessing (line 96, column 31 - line 98, column 48): " + [ v1.constructor.name ]);
                                })()
                            });
                        };
                        if (partingIndex instanceof Data_Maybe.Nothing) {
                            return err("DataProcessing.updateReverseWindow findIndex returned Nothing, coalesceInterval is probably zero");
                        };
                        throw new Error("Failed pattern match at Fusion.DataProcessing (line 92, column 15 - line 103, column 109): " + [ partingIndex.constructor.name ]);
                    })())(function (newModel) {
                        return pure(newModel);
                    });
                });
            };
        };
    };
};
var updateForwardWindow = function (dictMonadError) {
    var MonadThrow0 = dictMonadError.MonadThrow0();
    var throwError = Control_Monad_Error_Class.throwError(MonadThrow0);
    var Monad0 = MonadThrow0.Monad0();
    var discard1 = discard(Monad0.Bind1());
    var Applicative0 = Monad0.Applicative0();
    var for_ = Data_Foldable.for_(Applicative0)(Data_Foldable.foldableMaybe);
    var when = Control_Applicative.when(Applicative0);
    var pure = Control_Applicative.pure(Applicative0);
    return function (v) {
        return function (event) {
            return function (model) {
                var err = function (message) {
                    return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl68.value)(message));
                };
                return discard1(for_(Data_List.head(model.window))(function (head) {
                    return when(greaterThan(head.timestamp)(event.timestamp))(err("DataProcessing.updateForwardWindow: event has earlier timestamp then its predecessor: " + show(event)));
                }))(function () {
                    var v1 = Data_List.head(model.window);
                    if (v1 instanceof Data_Maybe.Nothing) {
                        return pure({
                            window: new Data_List_Types.Cons(event, model.window),
                            windowStart: model.windowStart
                        });
                    };
                    if (v1 instanceof Data_Maybe.Just) {
                        var shouldReset = greaterThanOrEq(Fusion_Data_Timestamp.diff(v1.value0.timestamp)(model.windowStart))(v.coalesceInterval);
                        if (shouldReset) {
                            return pure({
                                window: Data_List.singleton(event),
                                windowStart: v1.value0.timestamp
                            });
                        };
                        return pure({
                            window: new Data_List_Types.Cons(event, model.window),
                            windowStart: model.windowStart
                        });
                    };
                    throw new Error("Failed pattern match at Fusion.DataProcessing (line 123, column 3 - line 141, column 12): " + [ v1.constructor.name ]);
                });
            };
        };
    };
};
var update = function (dictMonadError) {
    var Monad0 = (dictMonadError.MonadThrow0()).Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var updateReverseWindow1 = updateReverseWindow(dictMonadError);
    var updateForwardWindow1 = updateForwardWindow(dictMonadError);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (v) {
        return function (event) {
            return function (v1) {
                return bind(updateReverseWindow1({
                    coalesceInterval: v.coalesceInterval
                })(event)({
                    reverseWindow: v1.reverseWindow,
                    reverseWindowStart: v1.reverseWindowStart
                }))(function (reverseModel) {
                    return bind(updateForwardWindow1({
                        coalesceInterval: v.coalesceInterval
                    })(event)({
                        window: v1.window,
                        windowStart: v1.windowStart
                    }))(function (forwardModel) {
                        return pure({
                            reverseWindow: reverseModel.reverseWindow,
                            reverseWindowStart: reverseModel.reverseWindowStart,
                            window: forwardModel.window,
                            windowStart: forwardModel.windowStart
                        });
                    });
                });
            };
        };
    };
};
var intermediateSpeed = function (v) {
    return function (v1) {
        var v2 = Data_List.head(v1.window);
        if (v2 instanceof Data_Maybe.Nothing) {
            return Data_Maybe.Nothing.value;
        };
        if (v2 instanceof Data_Maybe.Just) {
            var intermediateIsDue = greaterThanOrEq(Fusion_Data_Timestamp.diff(v2.value0.timestamp)(v1.windowStart))(v.coalesceInterval);
            if (intermediateIsDue) {
                return windowSpeed(v1);
            };
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Fusion.DataProcessing (line 145, column 3 - line 154, column 18): " + [ v2.constructor.name ]);
    };
};
var initialNtmStreamModel = function (windowStart) {
    return {
        reverseWindow: [  ],
        reverseWindowStart: windowStart,
        window: Data_List_Types.Nil.value,
        windowStart: windowStart
    };
};
var currentSpeed = function (v) {
    var v1 = Data_Array.last(v.reverseWindow);
    if (v1 instanceof Data_Maybe.Nothing) {
        return Data_Maybe.Nothing.value;
    };
    if (v1 instanceof Data_Maybe.Just) {
        var duration = Fusion_Data_Timestamp.diff(v1.value0.timestamp)(v.reverseWindowStart);
        var bytes = fold1(map1(function (v2) {
            return v2.loadedBytes;
        })(v.reverseWindow));
        var speed = Fusion_Data_Speed.bytesPerDuration(bytes)(duration);
        return new Data_Maybe.Just({
            speed: speed,
            timestamp: v1.value0.timestamp
        });
    };
    throw new Error("Failed pattern match at Fusion.DataProcessing (line 43, column 3 - line 54, column 12): " + [ v1.constructor.name ]);
};
export {
    currentSpeed,
    initialNtmStreamModel,
    intermediateSpeed,
    update,
    windowSpeed
};
